import {EAppEnvironment} from "./Common";
import {applyContainsPolyfill} from "./Polyfills/Closest";
//import {handleCookies} from "./Cookies/Handler";
import {handleAmountSpinners} from "./AmountSpinner/Handler";

export let appEnvironment = EAppEnvironment.production;

(() => {
    console.log("Příliš žluťoučký kůň úpěl ďábelské ódy");

    applyContainsPolyfill();

    if (localStorage.getItem("environment") === "development") {
        appEnvironment = EAppEnvironment.development;
    }

    handleAmountSpinners();
    //handleCookies();
})();